import styled, { css } from "styled-components";
import { theme } from "../../styles/theme";

export const Input = styled.input`
  width: 100%;
  padding: ${theme.spacing.sm} ${theme.spacing.lg};
  border-radius: ${theme.borderRadius.lg};
  background-color: ${theme.colors.background.quaternary};
  border: 1px solid ${theme.colors.stroke.subtle};
  color: ${theme.colors.text.primary};
  font-size: ${theme.typography.fontSize.base};
  transition: border-color ${theme.transitions.fast}, background-color ${theme.transitions.fast};

  &::placeholder {
    color: ${theme.colors.text.muted};
  }

  &:focus-visible {
    border-color: ${theme.colors.stroke.accent};
    background-color: ${theme.colors.background.muted};
    outline: none;
    box-shadow: 0 0 0 3px rgba(45, 212, 191, 0.15);
  }

  ${({ error }) =>
    error &&
    css`
      border-color: ${theme.colors.status.error};
      box-shadow: 0 0 0 3px rgba(248, 113, 113, 0.15);
    `}

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const Label = styled.label`
  display: block;
  margin-bottom: ${theme.spacing.xs};
  font-size: ${theme.typography.fontSize.sm};
  font-weight: ${theme.typography.fontWeight.medium};
  color: ${theme.colors.text.secondary};
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

export const ErrorMessage = styled.span`
  display: block;
  margin-top: ${theme.spacing.xs};
  font-size: ${theme.typography.fontSize.xs};
  color: ${theme.colors.status.error};
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: ${theme.spacing.sm} ${theme.spacing.lg};
  border-radius: ${theme.borderRadius.lg};
  background-color: ${theme.colors.background.quaternary};
  border: 1px solid ${theme.colors.stroke.subtle};
  color: ${theme.colors.text.primary};
  font-size: ${theme.typography.fontSize.base};
  font-family: inherit;
  resize: vertical;
  transition: border-color ${theme.transitions.fast}, background-color ${theme.transitions.fast};

  &::placeholder {
    color: ${theme.colors.text.muted};
  }

  &:focus-visible {
    border-color: ${theme.colors.stroke.accent};
    background-color: ${theme.colors.background.muted};
    outline: none;
    box-shadow: 0 0 0 3px rgba(45, 212, 191, 0.15);
  }

  ${({ error }) =>
    error &&
    css`
      border-color: ${theme.colors.status.error};
      box-shadow: 0 0 0 3px rgba(248, 113, 113, 0.15);
    `}

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xs};
  margin-bottom: ${theme.spacing.lg};
`;


